import React from 'react'
import './Icon.module.css'
import spriteSvg from "../../svg/sprite.svg"

function Icon (props) {

  let renderedIcon;
  if (props.id) {
      renderedIcon = (
        <svg className={props.className} style={props.style}>
          <use xlinkHref={`${spriteSvg}#${props.id}`}/>
        </svg>
      )
    }

    if (props.path) {
      renderedIcon = (
        <img id={props.id} className={props.className} style={props.style} height={props.height} width={props.width} src={props.path} alt={props.alt} onClick={props.onClick}/>)
    }

    return renderedIcon
}
export default Icon
